import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { LinksService } from 'shared/domain';
import { ChipComponent, FormFieldImports, IconDirective, InputDirective, TooltipDirective } from 'shared/ui-common';

import { LinkElementType, Guideline } from '@treetop/shared/model';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-anchor-link-search-popover-guideline',
  templateUrl: './anchor-link-search-popover-guideline.component.html',
  styleUrls: ['./anchor-link-search-popover-guideline.component.scss'],
  imports: [ChipComponent, IconDirective, TranslocoPipe, FormsModule, TooltipDirective, MatIconModule, InputDirective, FormFieldImports],
})
export class AnchorLinkSearchPopoverGuidelineComponent {
  private linksService = inject(LinksService);

  @Input() public guideline: Guideline;
  @Output() public clearSelectedGuideline = new EventEmitter();
  @Output() public linkSelected = new EventEmitter();

  protected loading = signal(false);

  protected results = signal<any[]>([]);

  protected searchTerm = signal('');

  protected showHint = computed(() => {
    return this.searchTerm().length > 0 && this.searchTerm().length < 3;
  });

  protected handleSearchChanged(searchTerm: string): void {
    if (searchTerm.length < 3) {
      this.results.set([]);
      return;
    }

    this.loading.set(true);

    if (searchTerm?.length >= 3) {
      const searchResults = this.linksService.searchForValueInGuideline(this.guideline, searchTerm);
      const searchResultsWithGuidelineUniqueIds = searchResults.map((result) => {
        return {
          ...result,
          externalGuidelineUniqueId: this.guideline.uniqueId,
        };
      });

      this.results.set(searchResultsWithGuidelineUniqueIds);
    }

    this.loading.set(false);
  }

  protected readonly LinkElementType = LinkElementType;
}
